import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const CampaignGroupFilterHolder = styled.div`
  padding: 0 10px;

  @media only screen and (max-width: 767px) {
    padding: 0;
  }

  .groupFilter {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
  }

  .contentGroupFilter {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .groupFilterButton {
    margin-bottom: 5px;
  }

  .distributedBy {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 6px;
  }

  .distributedBySelect {
    width: 180px;
    max-width: 100%;
  }

  .ant-scroll-number.ant-badge-count {
    color: ${Colors.white};
    p {
      color: ${Colors.white} !important;
    }
  }
`;

export default CampaignGroupFilterHolder;
